import { FC } from 'react'
import cx from 'classnames'
import styles from './styles.module.scss'
import { ImageFit } from '@/components/Sections/PageHero'
import { CmsResponsiveImage } from '@/components/ComposedPage/types'
import { DynamicImage } from '@/components/DynamicImage'

export interface CardImageProps {
  hideImageOnMobile?: boolean
  imageFit?: ImageFit
  image: CmsResponsiveImage
  className?: string
}

export const CardImage: FC<CardImageProps> = ({
  hideImageOnMobile = false,
  imageFit,
  image,
  className,
}) => {
  return (
    <div
      className={cx(styles.cardImage, className, {
        [styles.hiddenOnMobile]: Boolean(hideImageOnMobile),
      })}
    >
      <DynamicImage
        style={{
          objectFit: imageFit || ImageFit.CONTAIN,
        }}
        image={image}
        alt={image.fields.title}
        fill
        sizes="(max-width: 720px) 100vw, 1200px"
      />
    </div>
  )
}
